import { Logger } from "@wemade-vsf/core";
const loadPageCommand = {
  execute: async (context, params) => {
    var _a;
    Logger.debug("[Magento]: Load CMS Page content", { params });
    const { data } = await context.$magento.api.cmsPage(params.identifier, (_a = params.customQuery) != null ? _a : null, params == null ? void 0 : params.customHeaders);
    Logger.debug("[Result]:", { data });
    return data.cmsPage;
  }
};
export {
  loadPageCommand
};
